import {css} from 'styled-components'

export const Gmarket_DisPlay1_b80 = css`
  font-size: 80px;
  line-height: 100px;
   font-weight: 700;
  font-family: 'GmarketSans', sans-serif;
`
export const Gmarket_DisPlay1_b70 = css`
  font-size: 70px;
  line-height: 90px;
   font-weight: 700;
  font-family: 'GmarketSans', sans-serif;
`
export const Gmarket_DisPlay1_b32 = css`
  font-size: 32px;
  line-height:normal;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_DisPlay1_b28 = css`
  font-size: 28px;
  line-height:normal;
  font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`

export const Gmarket_DisPlay2_b50 = css`
  font-size: 50px;
  line-height:normal;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_DisPlay2_b40 = css`
  font-size: 40px;
  line-height:normal;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_DisPlay2_b30 = css`
  font-size: 30px;
  line-height: 1.4;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_DisPlay2_b24 = css`
  font-size: 24px;
  line-height: 1.4;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_DisPlay2_b20 = css`
  font-size: 20px;
  line-height: 30px;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_DisPlay3_b34 = css`
  font-size: 34px;
  line-height:48px;
   font-weight: 700;
  font-family: "GmarketSans", sans-serif;
`
export const Gmarket_Sunbeading_r24 = css`
  font-size: 24px;
  line-height: 38px;
   font-weight: 500;
  font-family: "GmarketSans", sans-serif;
`
